
const utils = {
  domain: "",
  getStorageValue (key, field) {
    if ('localStorage' in window) {
      let item = window.localStorage.getItem(key)
      if (field) {
        return JSON.parse(item)[field]
      }
      return item
    }
    return ''
  },
  setStorageValue (key, str) {
    if ('localStorage' in window) {
      window.localStorage.setItem(key, str)
    }
  },
  setCookie (name, value, days) {
    utils.eraseCookie(name)
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toGMTString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; domain=' + utils.getDomain()
  },
  getCookie (name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  },
  eraseCookie (name) {
    document.cookie = name + '=; Max-Age=-99999999;'
    document.cookie = name + '=; Max-Age=-99999999; domain=' + utils.getDomain()
  },
  deleteCookie (name) {
    const date = new Date()
    //qimenpan_token=aa;expires=Wed, 11 Dec 2019 08:02:10 GMT
    // date.setTime(date.getTime())
    document.cookie = name + '=a;expires=' + date.toGMTString()
  },
  getDomain () {
    if (utils.domain) {
      return utils.domain
    }
    // 不支持 .com.cn 这种，
    const domain = document.domain.toLowerCase()
    const match = domain.match(/([a-z-_]+\.)?[a-z-_]+$/)
    utils.domain = match ? match[0] : domain
    return domain
  },
  getToken () {
    return utils.getCookie('qimenpan_token')
  },
  isIos () {
    return navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)
  },
  isAndroid () {
    return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
  },
  isWeiXin () {
    return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
  },
  isPhoneNumber(number) {
    return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(number)
  },
  /**
   * 脱敏
   * @param arguments 多个要脱敏数据
   */
  publicDesensitization () {
    // 先将内置的 arguments 转换为真正的数组
    let dataArr = Array.prototype.slice.apply(arguments)
    for (let i = 0; i < dataArr.length; i++) {
      let data = dataArr[i]
      if (typeof data !== 'string') {
        continue
      }
      // 正则判断返回相应数据
      if (/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(data) || /^(13[0-9]|16[0-9]|19[0-9]|147|15[0-9]|17[6-8]|18[0-9])\d{8}|17[0-9]\d{8}$/.test(data) || /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/.test(data)) {
        // 身份证号 || 手机号  ||  营业执照    前三后四
        data = data.substr(0, 3) + '****' + data.substr(-4)
      } else if (/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(data)) {
        // 邮箱号码  前二 后以 @ 分割
        data = data.substr(0, 2) + '****' + data.substr(data.indexOf('@'))
      } else if (/^\d{16}|\d{19}$/.test(data)) {
        // 银行卡号  后四位
        data = '****' + data.substr(-4)
      } else if (data.indexOf('公司') > -1) {
        // 企业名称  前二后四
        data = data.substr(0, 2) + '****' + data.substr(-4)
      } else if (/^\d{6,7}$/.test(data)) {
        data = data.substr(0, 2) + '**' + data.substr(-2)
      } else {
        let raw = dataArr[0]
        let len = dataArr[1] || 6
        if (raw) {
          data = data.substr(0, len) + '****'
        }
      }
      dataArr[i] = data
    }
    return dataArr
  },
  dateFormatter (ts, tpl = 'Y-M-D H:m:s') { 
    // if (typeof ts === 'string') {
    //   ts = parseInt(ts)
    // }
    const date = new Date(ts)
    const dateObj = {
      Y: date.getFullYear(),
      M: utils.leftpad(date.getMonth() + 1),
      D: utils.leftpad(date.getDate()),
      H: utils.leftpad(date.getHours()),
      m: utils.leftpad(date.getMinutes()),
      s: utils.leftpad(date.getSeconds())
    }
    for (var key in dateObj) {
      tpl = tpl.replace(key, dateObj[key])
    }
    return tpl
  },
  leftpad (num) {
    return num < 10 ? '0' + num : '' + num
  }
}

export default utils